import * as actionTypes from "./actionTypes";
import axios from "./../../axios-api";

export const fetchSearch = (lang) => {
  const langArray = JSON.parse(import.meta.env.CLIENT_REACT_APP_LANGUAGE);
  let OriginLanguage = langArray.includes(lang) ? lang : "en-gb";
  return (dispatch) => {
    dispatch(fetchSearchStart());
    axios
      .get(`/search/${OriginLanguage}`)
      .then((response) => {
        dispatch(fetchSearchSuccess(response.data));
      })
      .catch((err) => {
        console.log("Error in front end search.");
      });
  };
};

export const fetchSearchStart = () => {
  return {
    type: actionTypes.FETCH_SEARCH_START,
  };
};

export const fetchSearchSuccess = (data) => {
  return {
    data: data,
    type: actionTypes.FETCH_SEARCH_SUCCESS,
  };
};

export const fetchSearchFail = (error) => {
  return {
    type: actionTypes.FETCH_SEARCH_FAIL,
    error: error,
  };
};
